module.exports = __webpack_public_path__ + "img/Social_1.ab92dfd6.webp";